import { connect } from 'react-redux';
import { getModals } from './redux/selectors';
import { popModal } from './redux/actionCreators';
import { getCurrentUser } from '../publicSession/selectors';
import { takeLast } from '../utils/fp';
/** 2 for now to support a modal + a confirmation modal on top */
var ARBITRARY_MODAL_LIMIT = 2;
export var mapStateToProps = function (state) { return ({
    modals: takeLast(ARBITRARY_MODAL_LIMIT, getModals(state)),
    currentUser: getCurrentUser(state),
}); };
export var mapDispatchToProps = {
    popModal: popModal,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Modals.container.js.map